import {
  useLazyQuery,
  useMutation,
  useQuery,
  useSubscription,
} from "@apollo/client";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import {
  QUERY_AVAILABLE_REPLAY_SEASONS,
  QUERY_REPLAY_EVENTS_FOR_SEASON,
  QUERY_REPLAY_SESSIONS_FOR_EVENT,
  QUERY_PROCESSED_SESSION_DATA_AND_V2_MERGED,
  QUERY_CURRENT_REPLAY_STATE,
  MUTATE_SET_REPLAY_SESSION_IS_REAL,
  MUTATE_START_REPLAY,
  MUTATE_STOP_REPLAY,
  SUBSCRIBE_REPLAY_STATE_UPDATE,
} from "../queries/replayQueries";
import {
  setAvailableReplaySeasons,
  setReplayEventsForSeason,
  setReplaySessionsForEvent,
  setSessionEventData,
  setLoadingSeasons,
  setLoadingEvents,
  setLoadingSessions,
  setLoadingSessionEventData,
  setReplayState,
  updateReplayState,
} from "../../../state/replayReducer";

export function QueryAvailableReplaySeasons() {
  const dispatch = useDispatch();
  const { data, loading, error } = useQuery(QUERY_AVAILABLE_REPLAY_SEASONS);

  useEffect(() => {
    dispatch(setLoadingSeasons(loading));
  }, [dispatch, loading]);

  useEffect(() => {
    if (error) {
      console.log(error);
    }
    if (data) {
      dispatch(setAvailableReplaySeasons(data.getAvailableReplaySeasons));
    }
  }, [dispatch, data, error]);
}

export function QueryReplayEventsForSeason() {
  const dispatch = useDispatch();
  const [queryEvents, { data, loading, error }] = useLazyQuery(
    QUERY_REPLAY_EVENTS_FOR_SEASON,
  );

  useEffect(() => {
    dispatch(setLoadingEvents(loading));
  }, [dispatch, loading]);

  useEffect(() => {
    if (error) {
      console.log(error);
    }
    if (data) {
      dispatch(setReplayEventsForSeason(data.getReplayEventsForSeason));
    }
  }, [dispatch, data, error]);

  return (season: number) => {
    queryEvents({ variables: { season } });
  };
}

export function QueryReplaySessionsForEvent() {
  const dispatch = useDispatch();
  const [querySessions, { data, loading, error }] = useLazyQuery(
    QUERY_REPLAY_SESSIONS_FOR_EVENT,
  );

  useEffect(() => {
    dispatch(setLoadingSessions(loading));
  }, [dispatch, loading]);

  useEffect(() => {
    if (error) {
      console.log(error);
    }
    if (data) {
      dispatch(setReplaySessionsForEvent(data.getReplaySessionsForEvent));
    }
  }, [dispatch, data, error]);

  return (season: number, eventName: string) => {
    querySessions({ variables: { season, eventName } });
  };
}

export function QueryProcessedSessionDataAndV2Merged() {
  const dispatch = useDispatch();
  const [queryProcessedSessionDataAndV2Merged, { data, loading, error }] =
    useLazyQuery(QUERY_PROCESSED_SESSION_DATA_AND_V2_MERGED);

  useEffect(() => {
    dispatch(setLoadingSessionEventData(loading));
  }, [dispatch, loading]);

  useEffect(() => {
    if (error) {
      console.log(error);
    }
    if (data) {
      dispatch(
        setSessionEventData({
          v2Merged: data.getProcessedSessionDataAndV2Merged.v2Merged,
          processedSessionData:
            data.getProcessedSessionDataAndV2Merged.processedSessionData,
        }),
      );
    }
  }, [dispatch, data, error]);

  return (sessionId: string) => {
    queryProcessedSessionDataAndV2Merged({ variables: { sessionId } });
  };
}

export function SetReplaySessionIsReal() {
  const [setReplaySessionIsReal] = useMutation(
    MUTATE_SET_REPLAY_SESSION_IS_REAL,
  );
  return setReplaySessionIsReal;
}

export function QueryCurrentReplayState() {
  const dispatch = useDispatch();
  const { data, error } = useQuery(QUERY_CURRENT_REPLAY_STATE);

  useEffect(() => {
    if (error) {
      console.log(error);
    }
    if (data) {
      dispatch(setReplayState(data.getCurrentReplayState));
    }
  }, [dispatch, data, error]);
}

export function StartReplay() {
  const [startReplay] = useMutation(MUTATE_START_REPLAY);
  return startReplay;
}

export function StopReplay() {
  const [stopReplay] = useMutation(MUTATE_STOP_REPLAY);
  return stopReplay;
}

export function SubscribeReplayStateUpdate() {
  const dispatch = useDispatch();
  const { error } = useSubscription(SUBSCRIBE_REPLAY_STATE_UPDATE, {
    onData: (x) => {
      const newReplayState = x.data?.data?.newReplayStateUpdate;
      dispatch(updateReplayState(newReplayState));
    },
  });
  if (error) {
    console.log(error);
  }
}
